import SlotsList from './SlotsList';

export default SlotsList;
